import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsBody,
  PostApplicationsResponse,
} from "api/api/applicationsApi/types";

export const postApplications = createAsyncThunk<
  PostApplicationsResponse,
  PostApplicationsBody
>("applications/postApplications", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplications(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
